import { render } from "./RestaurantsView.vue?vue&type=template&id=59c18044&scoped=true"
import script from "./RestaurantsView.vue?vue&type=script&lang=js"
export * from "./RestaurantsView.vue?vue&type=script&lang=js"

import "./RestaurantsView.vue?vue&type=style&index=0&id=59c18044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c18044"]])

export default __exports__